import React from 'react'
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, ResponsiveContainer, LabelList, ReferenceLine } from 'recharts'
import { useResultsContext } from '../context/context'
import { TeamsWithColours } from '../RoundResults'

interface Props {
  data: any[]
  teams: TeamsWithColours[]
  formatter?: (val: number) => string | number
  maxYAxisvalue: number
  minYAxisvalue: number
  numberOfTicks: number
  withoutCpuTeams?: boolean
}

const Legend = (val: any, colour: string): React.FC => (props: any) => {
  const { x, y, width, height, value } = props
  if (value == null) {
    return null
  }
  return <g>
    <text x={x + width / 2} y={y + height + 20} fill={colour} textAnchor="middle" font-weight="bold" font-size='0.8rem'>
      {val}
    </text>
  </g>
}

const ResultsBarChart: React.FC<Props> = ({ data, formatter, maxYAxisvalue, minYAxisvalue, numberOfTicks }) => {
  const x = window.matchMedia('(max-width: 1010px)')

  const context = useResultsContext()

  return (
    <ResponsiveContainer width='100%' height='100%' debounce={1}>
      <BarChart
        data={data}
        margin={{
          top: 20,
          right: 50,
          bottom: 40,
        }}
        // hacky way of handling media query for bar width
        barCategoryGap={x.matches ? -55 : -25}
        maxBarSize={x.matches ? -25 : -65}
      >
        <CartesianGrid vertical={false} />
        <ReferenceLine y={0} stroke='#000' />
        <XAxis dataKey='name' tickLine={false} padding={{ left: 75, right: 75 }} hide={true} />
        <YAxis axisLine={false} tickLine={false} tickCount={numberOfTicks + 1} tickFormatter={formatter ? (tick) => formatter(tick) : (tick) => tick} domain={[minYAxisvalue ?? 'auto', maxYAxisvalue ?? 'auto']} />
        {/* <Legend wrapperStyle={{ bottom: 20, left: 0, right: 0 }} /> */}
        {data.map((d, idx) => {
          return (
            <Bar key={`bar-item-${idx}`} name={d.name} type='natural' dataKey={d.key} fill={d.colour} animationDuration={context.noAnimations ? 0 : 1000} animationBegin={context.noAnimations ? 0 : idx * 1000}>
              <LabelList position='top' content={d.topLabel}></LabelList>
              {d.hasMiddleLabel && <LabelList position='middle' content={d.content}></LabelList>}
              <LabelList position='bottom' content={Legend(d.name, d.colour)}></LabelList>
            </Bar>
          )
        })}
      </BarChart>
    </ResponsiveContainer>
  )
}

export default ResultsBarChart
